import {
  Button,
  closeCurrentDialog,
  Form,
  FormButton,
  FormField,
  FormSubmitHandler,
} from 'platform/components';
import {HStack, Show, VStack} from 'platform/foundation';

import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

export interface SourcingFilterPresetFormData {
  name: string;
  allowNotifications: boolean | null;
}

interface SourcingFilterPresetDialogProps {
  initialValues: SourcingFilterPresetFormData;
  onSubmit?: FormSubmitHandler<SourcingFilterPresetFormData>;
}

export function FilterPresetForm(props: SourcingFilterPresetDialogProps) {
  return (
    <Form<SourcingFilterPresetFormData>
      onSubmit={props.onSubmit}
      defaultValues={props.initialValues}
    >
      {(control) => (
        <VStack spacing={4}>
          <FormField
            control={control}
            name="name"
            label={i18n.t('entity.sourcing.filterPresets.labels.filterName')}
            helperText={i18n.t('entity.sourcing.filterPresets.labels.maxLengthOfName')}
            maxLength={30}
            type="text"
            isAutoFocused
            data-testid={testIds.sourcing.classifieds('filterPresetName')}
          />
          <Show when={isNotNil(props.initialValues.allowNotifications)}>
            <FormField
              type="switch"
              control={control}
              name="allowNotifications"
              label={i18n.t('entity.sourcing.filterPresets.labels.allowNotifications')}
              data-testid={testIds.sourcing.classifieds('filterPresetAllowNotifications')}
            />
          </Show>
          <HStack justify="flex-end" spacing={4}>
            <Button
              variant="outlined"
              title={i18n.t('general.actions.close')}
              onClick={closeCurrentDialog}
              data-testid={testIds.sourcing.classifieds('filterPresetClose')}
            />
            <FormButton
              control={control}
              type="submit"
              title={i18n.t('general.actions.save')}
              data-testid={testIds.sourcing.classifieds('filterPresetSave')}
            />
          </HStack>
        </VStack>
      )}
    </Form>
  );
}
